import { render } from "./ModalDeletePlans.vue?vue&type=template&id=3f9f4a55"
import script from "./ModalDeletePlans.vue?vue&type=script&lang=js"
export * from "./ModalDeletePlans.vue?vue&type=script&lang=js"

import "./ModalDeletePlans.vue?vue&type=style&index=0&id=3f9f4a55&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__